var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var {
  AppRegistry,
  View,
  StyleSheet,
} = ReactNative;

var Svg = require('./wrappers/react-native-svg-wrapper');
var {
    Path,
    G,
    Circle
} = Svg;

function polarToCartesian(centerX, centerY, radius, angleInDegrees)
{
  var angleInRadians = angleInDegrees * Math.PI / 180.0;
  var x = centerX + radius * Math.cos(angleInRadians);
  var y = centerY + radius * Math.sin(angleInRadians);
  return [x,y];
}

function svgArc(startAngle, endAngle, percentage, dimension)
{
  var anglesStartedEqual = startAngle == endAngle;

  while(startAngle < 0) startAngle += 360;
  while(endAngle < 0 || endAngle < startAngle) endAngle += 360;

  if( percentage == 1 && startAngle == endAngle ) endAngle += 359;

  var portionAngle = ((endAngle - startAngle))*(percentage);
  var stopAngle = startAngle+portionAngle;

  var center = dimension/2;
  var dist = 4*dimension/10;
  var [sx,sy] = polarToCartesian(center, center, dist, startAngle%360);
  var [ex,ey] = polarToCartesian(center, center, dist, stopAngle);

  var flag = (stopAngle-startAngle)%360 < 180 ? "0" : "1";

  return "M "+ex+" "+ey+" A "+dist+" "+dist+" 0 "+flag+" 0 "+sx+" "+sy;
}


var ArcMeter = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style : {},
      appManager : null,
      dimension : 100,
      thickness : 10,
      startAngle : 90,
      endAngle : 90,
      percentage : 0.5,
      children : <View />,
      fgColor : 'red',
      bgColor : 'blue',
      animated : true,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      rewards : [],
      angle : 10,
      percentage : new Animated.Value(0),
      percentageVal : 0,
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    this.state.percentage.addListener(({value}) =>
    {
      thisThing.setState({percentageVal:value})
    });

    setTimeout(()=>
    {
      thisThing._hasDoneFirstSet = true;
      thisThing.setPercentage(thisThing.props.percentage);
    }, 500)
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.percentage !== 'undefined' ) this.setPercentage(newProps.percentage);
  },

  _hasDoneFirstSet : false,
  setPercentage : function(newPercentage)
  {
    if( !this._hasDoneFirstSet ) return;

    Animated.spring(
      this.state.percentage,
      {
        toValue: newPercentage,
        tension: 8,
        friction: 9,
      },
    ).start();
  },

  render : function()
  {
    var outerSVG = svgArc(this.props.startAngle, this.props.endAngle, 1, this.props.dimension);
    var innerSVG = svgArc(this.props.startAngle+1, this.props.endAngle-1, this.state.percentageVal, this.props.dimension);

    return (
      <View pointerEvents={"none"} style={[{width:this.props.dimension,height:this.props.dimension},this.props.style]}>
        <Svg
          height={this.props.dimension}
          width={this.props.dimension}
        >

          {
            this.state.percentageVal <= 0 ?
            <G scale="1">
              <Path
                  d={outerSVG}
                  stroke={this.props.bgColor}
                  strokeWidth={this.props.thickness}
                  strokeLinecap={"round"}
                  fill="none"
              />
            </G>
            :
            <G scale="1">
              <Path
                  d={outerSVG}
                  stroke={this.props.bgColor}
                  strokeWidth={this.props.thickness}
                  strokeLinecap={"round"}
                  fill="none"
              />
              <Path
                  d={innerSVG}
                  stroke={this.props.fgColor}
                  strokeWidth={this.props.thickness-2}
                  strokeLinecap={"round"}
                  fill="none"
              />
            </G>
          }

        </Svg>
        <View style={{width:this.props.dimension, flexDirection:'column', alignItems:'center',justifyContent:'center',height:this.props.dimension,position:'absolute',top:0,left:0}}>
          {this.props.children}
        </View>
      </View>

    )
  }
})

module.exports = ArcMeter;
